/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaoBaoCopyProductVo
 */
export interface TaoBaoCopyProductVo {
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    shopSite?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    shopName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    shopOrderNo?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    proNm?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    proNmEn?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaoBaoCopyProductVo
     */
    options?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    size?: string;
    /**
     * 
     * @type {number}
     * @memberof TaoBaoCopyProductVo
     */
    proQty?: number;
    /**
     * 
     * @type {number}
     * @memberof TaoBaoCopyProductVo
     */
    proCost?: number;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    imgUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TaoBaoCopyProductVo
     */
    proUrl?: string;
}

/**
 * Check if a given object implements the TaoBaoCopyProductVo interface.
 */
export function instanceOfTaoBaoCopyProductVo(value: object): value is TaoBaoCopyProductVo {
    return true;
}

export function TaoBaoCopyProductVoFromJSON(json: any): TaoBaoCopyProductVo {
    return TaoBaoCopyProductVoFromJSONTyped(json, false);
}

export function TaoBaoCopyProductVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaoBaoCopyProductVo {
    if (json == null) {
        return json;
    }
    return {
        
        'shopSite': json['shopSite'] == null ? undefined : json['shopSite'],
        'shopName': json['shopName'] == null ? undefined : json['shopName'],
        'shopOrderNo': json['shopOrderNo'] == null ? undefined : json['shopOrderNo'],
        'proNm': json['proNm'] == null ? undefined : json['proNm'],
        'proNmEn': json['proNmEn'] == null ? undefined : json['proNmEn'],
        'options': json['options'] == null ? undefined : json['options'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'proQty': json['proQty'] == null ? undefined : json['proQty'],
        'proCost': json['proCost'] == null ? undefined : json['proCost'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'proUrl': json['proUrl'] == null ? undefined : json['proUrl'],
    };
}

export function TaoBaoCopyProductVoToJSON(json: any): TaoBaoCopyProductVo {
    return TaoBaoCopyProductVoToJSONTyped(json, false);
}

export function TaoBaoCopyProductVoToJSONTyped(value?: TaoBaoCopyProductVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shopSite': value['shopSite'],
        'shopName': value['shopName'],
        'shopOrderNo': value['shopOrderNo'],
        'proNm': value['proNm'],
        'proNmEn': value['proNmEn'],
        'options': value['options'],
        'color': value['color'],
        'size': value['size'],
        'proQty': value['proQty'],
        'proCost': value['proCost'],
        'imgUrl': value['imgUrl'],
        'proUrl': value['proUrl'],
    };
}

